export default __webpack_public_path__ + "static/media/inkfinder.8c0cf651.svg";